module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eng-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-game",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), _c('h4', {
    staticClass: "eng-header-title"
  }, [_vm._v(_vm._s(_vm.lessonName || "הרכבת משפטים"))]), _vm._v(" "), _c('div', [_c('inline-svg', {
    staticClass: "lives",
    attrs: {
      "src": require(("../../assets/svg/" + (3 - _vm.lost) + "lives.svg")).default
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e207f8d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EngGame/eng-header.vue
// module id = 438
// module chunks = 1 4